<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" style="width: 926px;">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="close()">
            <i class="icon-close"></i>
          </a>
          <h3
            :key="`Non-Visit-h3-${record.id}`"
            class="modal-title"
          >要保人{{record.name| getMaskName}}拜訪結果</h3>
        </div>
        <div
          class="modal-body send-modal-body"
          style="min-height:220px;"
          :class="{ 'section-loading': isLoading }"
        >
          <div class="form-group mt-3">
            <div class="radio radio-inline">
              <input type="radio" v-model="req.picked" id="radio-Non-001" value="001" />
              <label for="radio-Non-001">保戶已知保單狀況</label>
            </div>
            <br />
            <div class="radio radio-inline">
              <input type="radio" v-model="req.picked" id="radio-Non-002" value="002" />
              <label for="radio-Non-002">保戶不知保單狀況</label>
            </div>
            <br />
            <table border="0">
              <tr>
                <td width="10%"></td>
                <td >
                  <div class="radio radio-inline">
                  <input type="radio" v-model="reason" id="radio-Non-Yes" :disabled="is_disabled_pay" value="要繳費" />
                  <label for="radio-Non-Yes">要繳費</label>
                  </div>              
                </td>
                <td >
                  <div class="radio radio-inline">
                  <input type="radio" v-model="reason" id="radio-Non-No" :disabled="is_disabled_pay" value="不要繳費" />
                  <label for="radio-Non-No">不要繳費</label>
                  </div>              
                </td>
              </tr>
            </table>  
            <div class="radio radio-inline">
              <input type="radio" v-model="req.picked" id="radio-Non-003" value="003" />
              <label for="radio-Non-003">保戶拒訪</label>
            </div>
            <br />
            <div class="radio radio-inline">
              <input type="radio" v-model="req.picked" id="radio-Non-004" value="004" />
              <label for="radio-Non-004">
                保戶電話無人接聽或拜訪無法遇人
                <br />
                <span style="color:red">(電訪/拜訪時間1,2,3需填寫二天三個不同時段，月份日期不可皆為同一天，若相同則會出現提示訊息請更改)</span>
              </label>
            </div>
            <table border="0">
              <tr>
                <td width="5%"></td>
                <td width="17%">
                  <div>
                    <label>■ 電訪/拜訪時間1 &nbsp;</label>
                  </div>
                </td>
                <td>
                  <select
                    :id="`one-date-month-${colKey}`"
                    :data-vv-name="`one-date-month-${colKey}`"
                    v-validate="'required'"
                    data-vv-as="電訪/拜訪時間(1)"
                    class="form-control form-control-inline"
                    v-model="req.one_date[0]"
                    :class="{ 'is-invalid': errors.has(`one-date-month-${colKey}`) }"
                    :disabled="is_disabled"
                    @change="updateDate('one')"
                  >
                    <option value>月份</option>
                    <option
                      v-for="(opt, m_opt_i) in monthOpt"
                      :key="`one-month-${m_opt_i}`"
                      :value="opt"
                    >{{opt}}月</option>
                  </select>

                  <span class="text">/</span>

                  <select
                    :id="`one-date-day-${colKey}`"
                    :data-vv-name="`one-date-day-${colKey}`"
                    v-validate="'required'"
                    data-vv-as="電訪/拜訪時間(1)"
                    class="form-control form-control-inline"
                    v-model="req.one_date[1]"
                    :class="{ 'is-invalid': errors.has(`one-date-day-${colKey}`) }"
                    :disabled="is_disabled"
                    @change="updateDate('one')"
                  >
                    <option value>日期</option>
                    <option
                      v-for="(opt, d_opt_i) in dateOpt_start"
                      :key="`one-date-${d_opt_i}`"
                      :value="opt"
                    >{{opt}}日</option>
                  </select>

                  <span class="text">-</span>

                  <select
                    :id="`one-date-hour-${colKey}`"
                    :data-vv-name="`one-date-hour-${colKey}`"
                    v-validate="'required'"
                    data-vv-as="電訪/拜訪時間(1)"
                    class="form-control form-control-inline"
                    :class="{ 'is-invalid': errors.has(`one-date-hour-${colKey}`) }"
                    :disabled="is_disabled"
                    v-model="req.one_date[2]"
                  >
                    <option value>時</option>
                    <option
                      v-for="(opt, h_opt_i) in hourOpt"
                      :key="`one-hour-${h_opt_i}`"
                      :value="opt"
                    >{{opt}}</option>
                  </select>

                  <span class="text">：</span>

                  <select
                    :id="`one-date-time-${colKey}`"
                    :data-vv-name="`one-date-time-${colKey}`"
                    v-validate="'required'"
                    data-vv-as="電訪/拜訪時間(1)"
                    class="form-control form-control-inline"
                    :class="{ 'is-invalid': errors.has(`one-date-time-${colKey}`) }"
                    :disabled="is_disabled"
                    v-model="req.one_date[3]"
                  >
                    <option value>分</option>
                    <option
                      v-for="(opt, t_opt_i) in timeOpt"
                      :key="`one-time-${t_opt_i}`"
                      :value="opt"
                    >{{opt}}</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td width="5%"></td>
                <td width="17%">
                  <div>
                    <label>■ 電訪/拜訪時間2 &nbsp;</label>
                  </div>
                </td>
                <td>
                  <select
                    :id="`second-date-month-${colKey}`"
                    :data-vv-name="`second-date-month-${colKey}`"
                    v-validate="'required'"
                    data-vv-as="電訪/拜訪時間(2)"
                    class="form-control form-control-inline"
                    v-model="req.second_date[0]"
                    :class="{ 'is-invalid': errors.has(`second-date-month-${colKey}`) }"
                    :disabled="is_disabled"
                    @change="updateDate('second')"
                  >
                    <option value>月份</option>
                    <option
                      v-for="(opt, m_opt_i) in monthOpt"
                      :key="`second-month-${m_opt_i}`"
                      :value="opt"
                    >{{opt}}月</option>
                  </select>

                  <span class="text">/</span>

                  <select
                    :id="`second-date-day-${colKey}`"
                    :data-vv-name="`second-date-day-${colKey}`"
                    v-validate="'required'"
                    data-vv-as="電訪/拜訪時間(2)"
                    class="form-control form-control-inline"
                    v-model="req.second_date[1]"
                    :class="{ 'is-invalid': errors.has(`second-date-day-${colKey}`) }"
                    :disabled="is_disabled"
                    @change="updateDate('second')"
                  >
                    <option value>日期</option>
                    <option
                      v-for="(opt, d_opt_i) in dateOpt_start"
                      :key="`second-date-${d_opt_i}`"
                      :value="opt"
                    >{{opt}}日</option>
                  </select>

                  <span class="text">-</span>

                  <select
                    :id="`second-date-hour-${colKey}`"
                    :data-vv-name="`second-date-hour-${colKey}`"
                    v-validate="'required'"
                    data-vv-as="電訪/拜訪時間(2)"
                    class="form-control form-control-inline"
                    :class="{ 'is-invalid': errors.has(`second-date-hour-${colKey}`) }"
                    :disabled="is_disabled"
                    v-model="req.second_date[2]"
                  >
                    <option value>時</option>
                    <option
                      v-for="(opt, h_opt_i) in hourOpt"
                      :key="`second-hour-${h_opt_i}`"
                      :value="opt"
                    >{{opt}}</option>
                  </select>

                  <span class="text">：</span>

                  <select
                    :id="`second-date-time-${colKey}`"
                    :data-vv-name="`second-date-time-${colKey}`"
                    v-validate="'required'"
                    data-vv-as="電訪/拜訪時間(2)"
                    class="form-control form-control-inline"
                    :class="{ 'is-invalid': errors.has(`second-date-time-${colKey}`) }"
                    :disabled="is_disabled"
                    v-model="req.second_date[3]"
                  >
                    <option value>分</option>
                    <option
                      v-for="(opt, t_opt_i) in timeOpt"
                      :key="`second-time-${t_opt_i}`"
                      :value="opt"
                    >{{opt}}</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td width="5%"></td>
                <td width="17%">
                  <div>
                    <label>■ 電訪/拜訪時間3 &nbsp;</label>
                  </div>
                </td>
                <td>
                  <select
                    :id="`third-date-month-${colKey}`"
                    :data-vv-name="`third-date-month-${colKey}`"
                    v-validate="'required'"
                    data-vv-as="電訪/拜訪時間(3)"
                    class="form-control form-control-inline"
                    v-model="req.third_date[0]"
                    :class="{ 'is-invalid': errors.has(`third-date-month-${colKey}`) }"
                    :disabled="is_disabled"
                    @change="updateDate('third')"
                  >
                    <option value>月份</option>
                    <option
                      v-for="(opt, m_opt_i) in monthOpt"
                      :key="`third-month-${m_opt_i}`"
                      :value="opt"
                    >{{opt}}月</option>
                  </select>

                  <span class="text">/</span>

                  <select
                    :id="`third-date-day-${colKey}`"
                    :data-vv-name="`third-date-day-${colKey}`"
                    v-validate="'required'"
                    data-vv-as="電訪/拜訪時間(3)"
                    class="form-control form-control-inline"
                    v-model="req.third_date[1]"
                    :class="{ 'is-invalid': errors.has(`third-date-day-${colKey}`) }"
                    :disabled="is_disabled"
                    @change="updateDate('third')"
                  >
                    <option value>日期</option>
                    <option
                      v-for="(opt, d_opt_i) in dateOpt_start"
                      :key="`third-date-${d_opt_i}`"
                      :value="opt"
                    >{{opt}}日</option>
                  </select>

                  <span class="text">-</span>

                  <select
                    :id="`third-date-hour-${colKey}`"
                    :data-vv-name="`third-date-hour-${colKey}`"
                    v-validate="'required'"
                    data-vv-as="電訪/拜訪時間(3)"
                    class="form-control form-control-inline"
                    :class="{ 'is-invalid': errors.has(`third-date-hour-${colKey}`) }"
                    :disabled="is_disabled"
                    v-model="req.third_date[2]"
                  >
                    <option value>時</option>
                    <option
                      v-for="(opt, h_opt_i) in hourOpt"
                      :key="`third-hour-${h_opt_i}`"
                      :value="opt"
                    >{{opt}}</option>
                  </select>

                  <span class="text">：</span>

                  <select
                    :id="`third-date-time-${colKey}`"
                    :data-vv-name="`third-date-time-${colKey}`"
                    v-validate="'required'"
                    data-vv-as="電訪/拜訪時間(3)"
                    class="form-control form-control-inline"
                    :class="{ 'is-invalid': errors.has(`third-date-time-${colKey}`) }"
                    :disabled="is_disabled"
                    v-model="req.third_date[3]"
                  >
                    <option value>分</option>
                    <option
                      v-for="(opt, t_opt_i) in timeOpt"
                      :key="`third-time-${t_opt_i}`"
                      :value="opt"
                    >{{opt}}</option>
                  </select>
                </td>
              </tr>
            </table>
            <br />
            <br />
          </div>
          <div class="action text-right">
            <a @click.stop.prevent="submit()" class="btn btn-primary">提交</a>
          </div>
        </div>
      </div>
    </div>

    <!-- 提醒資訊-->
    <warning-modal
      :message="message"
      :open="warningModalOpen"
      :confirmText="'確定送出'"
      :cancelText="'回上一層'"
      @submit="ClosewarningModal()"
      @close="panelClose('warningModalOpen')"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
import { updateVisitResult } from "@/service";
import WarningModal from "@/desktop/components/WarningModal";
import VeeValidate, { Validator } from "vee-validate";
import zh_TW from "vee-validate/dist/locale/zh_TW";
import Vue from "vue";
Vue.use(VeeValidate);
Validator.localize("zh_TW", zh_TW);

const dictionary = {
  zh_TW: {
    messages: {
      required: field => `請輸入 ${field}`
    }
  }
};

Validator.localize(dictionary);

export default {
  name: "VisitResulstModal",
  mixins: [commonMixin],
  components: { WarningModal },
  props: {
    record: {
      // 客戶list 資料
      type: Object,
      default: () => {
        return null;
      }
    },
    open: {
      type: Boolean,
      default: false
    },
    catInfo: {
      // 專區資訊
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      today: window.moment(),
      warningModalOpen: false,
      message: "",
      nameBir: "",
      req: {
        result: "",
        picked: "",
        one_date: ["", "", "", ""],
        second_date: ["", "", "", ""],
        third_date: ["", "", "", ""]
      },
      monthOpt: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      hourOpt: [],
      timeOpt: [],
      dateOpt_start: [], //日期下拉選單
      colKey: "1", //串欄位key用
      type: String,
      isLoading: false,
      is_disabled: true,
      is_disabled_pay: true,
      visit_time: "",
      reason: "",
      resultType: ""
    };
  },
  watch: {
    open(val) {
      if (val) {
        this.Init();
      }
    },
    "req.picked": function(val) {
      if (val == "004") {
        this.is_disabled = false;
      } else {
        this.is_disabled = true;
      }
      if (val != "002") {
        this.reason = "";
        this.is_disabled_pay = true;
      }else{
        this.is_disabled_pay = false;
      }
    }
  },
  methods: {
    ...mapActions(["setPageLock"]),
    Init() {
      // 初始化
      this.req.picked = this.record.reply_code;
      if (this.req.picked == "002") {
        this.reason = this.record.reply_memo;
      } else if (this.req.picked == "004") {
        let memo = this.record.reply_memo.split(";"); //memo[0] = 1/1-02:03 --> memo[1] = 2/3-04:03 --> memo[2] = 3/3-03:04
        let memo_1 = memo[0].split("/"); //memo_1[0]= 1 --> memo_1[1]= -02:03
        let memo_2 = memo_1[1].split("-"); //memo_2[0]= 1 -->memo_2[1]= 02:03
        let memo_3 = memo_2[1].split(":"); //memo_3[0]= 02 -->memo_3[1]= 03
        this.req.one_date[0] = memo_1[0];
        this.req.one_date[1] = memo_2[0];
        this.req.one_date[2] = memo_3[0];
        this.req.one_date[3] = memo_3[1];
        this.updateDate("one");
        // ------------------------------------------------
        memo_1 = memo[1].split("/"); // memo[1] = 2/3-04:03
        memo_2 = memo_1[1].split("-");
        memo_3 = memo_2[1].split(":");
        this.req.second_date[0] = memo_1[0];
        this.req.second_date[1] = memo_2[0];
        this.req.second_date[2] = memo_3[0];
        this.req.second_date[3] = memo_3[1];
        this.updateDate("second");
        // ------------------------------------------------
        memo_1 = memo[2].split("/"); // memo[2] = 3/3-03:04
        memo_2 = memo_1[1].split("-");
        memo_3 = memo_2[1].split(":");
        this.req.third_date[0] = memo_1[0];
        this.req.third_date[1] = memo_2[0];
        this.req.third_date[2] = memo_3[0];
        this.req.third_date[3] = memo_3[1];
        this.updateDate("third");
      } else {
        this.reason = "";
        this.req.one_date = ["", "", "", ""];
        this.req.second_date = ["", "", "", ""];
        this.req.third_date = ["", "", "", ""];
      }

      this.registerHanlink(); // for 難字更新
      this.$validator.reset();
    },
    submit() {
      //檢核
      this.$validator.validateAll().then(el => {
        if (!el) {
          let errMsg = [];
          for (let i = 0; i < this.errors.items.length; i++) {
            errMsg.push(this.errors.items[i].msg);
          }
          let showErrMsg = [...new Set(errMsg)];
          showErrMsg.forEach(s => {
            this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
          });
          return;
        }
        this.$validator.reset();
        if (this.req.picked == "004") {
          if (
            this.req.one_date[0] == this.req.second_date[0] &&
            this.req.one_date[0] == this.req.third_date[0] &&
            this.req.second_date[0] == this.req.third_date[0]
          ) {
            if (
              this.req.one_date[1] == this.req.second_date[1] &&
              this.req.one_date[1] == this.req.third_date[1] &&
              this.req.second_date[1] == this.req.third_date[1]
            ) {
              this.setToastMsg("電訪/拜訪日期不可皆為同一天");
              return;
            }
          }
        }

        if (!this.req.picked) {
          this.setToastMsg("請至少選擇一項原因");
        } else if ((this.req.picked == "002") & !this.reason) {
          this.setToastMsg("請勾選要繳費/不繳費");
        } else {
          this.message =
            "<span>本次名單將列為後續重點查核項目，請確實填寫，謝謝!</span><br/>";
          this.panelOpen("warningModalOpen");
        }
      });
    },
    ClosewarningModal() {
      this.panelClose("warningModalOpen");
      if (this.req.picked == "004") {
        this.visit_time =
          this.req.one_date[0] +
          "/" +
          this.req.one_date[1] +
          "-" +
          this.req.one_date[2] +
          ":" +
          this.req.one_date[3] +
          ";" +
          this.req.second_date[0] +
          "/" +
          this.req.second_date[1] +
          "-" +
          this.req.second_date[2] +
          ":" +
          this.req.second_date[3] +
          ";" +
          this.req.third_date[0] +
          "/" +
          this.req.third_date[1] +
          "-" +
          this.req.third_date[2] +
          ":" +
          this.req.third_date[3];
        this.req.result = this.visit_time;
      } else if (this.req.picked == "002") {
        this.req.result = this.reason;
      } else {
        this.req.result = "";
      }
      let reportData = {
        picked: this.req.picked,
        result: this.req.result,
        plcno: this.record.plcno,
        userId: this.$store.state.userInfo.id,
        userName: this.$store.state.userInfo.name
      };
      this.isLoading = true; //開啟遮罩
      updateVisitResult(this.$store.state.userInfo.id, reportData).then(
        result => {
          this.isLoading = false; //關閉遮罩
          if (result.header && result.header.status == "200") {
            this.$toast.info({ title: result.header.message });
            this.close();
          } else {
            this.$toast.info({ title: result.header.message });
            this.close();
          }
        }
      );
    },
    close() {
      this.$emit("close");
    },
    //下架日期-下拉選單初始化
    updateDate(type) {
      let year = this.today.year();
      let month = "";
      if (type == "one") {
        month = this.req.one_date[0];
      } else if (type == "second") {
        month = this.req.second_date[0];
      } else if (type == "third") {
        month = this.req.third_date[0];
      }
      if (!year || !month) return;
      let dt = new Date(year, month, 0).getDate();
      this.dateOpt_start = [];
      for (let i = 0; i < dt; i++) {
        this.dateOpt_start.push(i + 1);
      }
    }
  },
  mounted() {
    let minuteStr = "";
    for (let i = 0; i < 60; i++) {
      if (i < 10) {
        minuteStr = "0" + i;
      } else {
        minuteStr = i;
      }
      this.timeOpt.push(minuteStr);
    }

    let hourStr = "";
    for (let i = 0; i < 24; i++) {
      if (i < 10) {
        hourStr = "0" + i;
      } else {
        hourStr = i;
      }
      this.hourOpt.push(hourStr);
    }
  }
};
</script>

<style>
.vdp-datepicker input {
  width: 100px;
  padding: 10px;
}
.select-100 {
  width: 170px;
}
.non-select-arrow {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: "";
}
.btn-grids .btn {
  position: relative;
  padding: 8px;
  width: 24%;
  font-size: 1rem;
  margin: 0px;
  margin-bottom: 10px;
  margin-right: 1%;
}
.btn-grids .add-new {
  padding: 8px;
  width: 50px !important;
  font-size: 16px;
}
.btn-grids .btn .close {
  position: absolute;
  right: -10px;
  top: -10px;
}
</style>